<template>
  <div :class="$style.root">
    <img
      :class="[$style.rootThumbnail, 'img-fluid']"
      :src="dataItem.image"
      :alt="dataItem.post_title"
      @click="onAdd"
    />

    <div class="mt-2">
      <div :class="$style.rootPrice">
        <b>{{ getFormatPrice(dataItem.price) }}</b>
      </div>

      <h5 class="text-center">{{ dataItem.post_title }}</h5>

      <div
        v-if="isAdded === true"
        class="d-flex align-items-center justify-content-center"
      >
        <b-form-input
          ref="quantityInput"
          v-model="compositionOrder.quantity"
          type="number"
          min="1"
          placeholder="Cantidad"
          style="width: 100px"
          @change="onChangeQuantity"
        ></b-form-input>

        <v-btn
          class="ml-2"
          color="#8643bb"
          dark
          fab
          height="28"
          width="28"
          x-small
          @click="onDelete"
        >
          x
        </v-btn>

        <!-- <ButtonSvg class="ml-2" @click="onDelete">
          <SvgTimesCircle :class="[$style.rootCloseIcon]" />
          <img :src="SvgTimesCircle" alt="" />
        </ButtonSvg> -->
      </div>
      <b-button v-else variant="bn-btn3" @click="onAdd"> Agregar </b-button>
    </div>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'

import CompositionOrder from '@/models/compositionOrder.model'
// import ButtonSvg from 'Components/common/ButtonSvg'
import FormatHelper from '@/helpers/FormatHelper.js'

// import SvgTimesCircle from 'Assets/svgs/times-circle-solid.svg'

@Component({
  components: {
    // ButtonSvg,
    // SvgTimesCircle,
  },
})
export default class ProductCompositionThumbOption extends Vue {
  @Prop({
    type: Object,
    required: true,
    default: () => {},
  })
  source

  get dataItem() {
    return this._.get(this.source, 'data', {})
  }

  onAdd() {
    this.$emit('onAdd')
  }

  getFormatPrice(price) {
    return FormatHelper.formatCurrency(price)
  }

  onChangeQuantity(val) {
    CompositionOrder.update({
      id: this.compositionOrder.id,
      quantity: parseInt(val),
    })
    this.$emit('onUpdate')
  }

  onDelete() {
    CompositionOrder.delete(this.compositionOrder.id)
    this.$emit('onUpdate')
  }

  get compositionOrder() {
    return CompositionOrder.find(this.dataItem.ID)
  }

  get isAdded() {
    return !!this.compositionOrder
  }
}
</script>

<style lang="scss" module>
.root {
  &--Thumbnail {
    cursor: pointer;
    object-fit: cover;
    height: 220px !important;
    width: 200px !important;
  }

  &--CloseIcon {
    width: 1.5rem;
  }
}
</style>
